import { defineNuxtPlugin } from '#app/nuxt';
import { isEnginePanicError } from '#layers/base/utils/error';
import { FETCH_TIMEOUT_MS } from '~/constants/fetch';
import { useErrorStore } from '~/stores/error';

export default defineNuxtPlugin((_nuxtApp) => {
	globalThis.$fetch = $fetch.create({
		timeout: FETCH_TIMEOUT_MS,
		onResponseError({ error, response, request }) {
			// access response error from parsed body
			// https://github.com/unjs/ofetch/issues/397
			const data = response._data;

			console.error(`[fetch]: request ${request} failed with:`, error ?? data);

			if (isEnginePanicError(data)) {
				useErrorStore().setGlobalError(data);
			}
		},
	});
});
